import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { AgencyModel } from '@urbanx/agx.agencies.client'
import { AgxAvatar, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import { useMemo } from 'react'
import { getAgencyInitials } from 'utils/agencyUtils'

interface TaskAgencyCellProps {
  task: AutopilotTaskDto
  agencies: AgencyModel[]
  index: number
  isNew?: boolean
}

const TaskAgencyCell = ({
  task,
  agencies,
  index,
  isNew,
}: TaskAgencyCellProps) => {
  const agency = useMemo(() => {
    return agencies.find((a) => a.id === task.agencyId)
  }, [task.agencyId, agencies])

  const agencyInitials = useMemo(
    () => getAgencyInitials(agency?.name),
    [agency?.name]
  )

  return (
    <AgxSpacer
      direction="horizontal"
      gap="spacing-md"
      contentAlignment="center"
    >
      {agency?.logoUrl && (
        <AgxAvatar type="image" size="sm" imageUri={agency.logoUrl} />
      )}
      {!agency?.logoUrl && (
        <AgxAvatar type="text-dark" size="sm" text={agencyInitials ?? 'UA'} />
      )}

      <AgxTypography
        id={`row-${index}-agency`}
        size="small"
        color={isNew ? 'var(--text-primary)' : 'var(--text-secondary)'}
        type={isNew ? 'body_ui_strong' : 'body_ui'}
      >
        {agency?.name || 'Unknown Agency'}
      </AgxTypography>
    </AgxSpacer>
  )
}

export default TaskAgencyCell
